module.exports = __webpack_public_path__ + "img/ideas-submit-banner-1200x900.256c76d4.png";